import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { put, takeEvery } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import { transformCountryBoundsDto } from 'data/transformers/country-bounds';
import { geocodeAddress } from 'data/utils/google';
import { transformNearbyDropOffPointDto } from 'data/transformers/nearby-drop-off-point';
import * as sessionSelectors from 'state/session/selectors';
import * as userAddressSelectors from 'state/user-address/selectors';
import * as conversationSelectors from 'state/conversation/selectors';
import * as api from 'data/api';
import * as statelessActions from './actions';
import { actions } from './slice';
import { DropOffPointSource } from './constants';
export function* fetchCountryBounds() {
  const sessionCountryId = yield* select(sessionSelectors.getCountryId);
  const address = yield* select(userAddressSelectors.getUserAddress);
  const countryId = (address === null || address === void 0 ? void 0 : address.countryId) || sessionCountryId;
  if (!countryId) return;
  const response = yield* call(api.getCountryBounds, countryId);
  if ('errors' in response) return;
  const countryBounds = transformCountryBoundsDto(response.country_bounds);
  yield put(actions.fetchCountryBoundsSuccess({
    countryBounds
  }));
}
export function* fetchNearbyDropOffPoints(_ref) {
  let {
    payload
  } = _ref;
  const address = yield* select(userAddressSelectors.getUserAddress);
  const userCountryCode = yield* select(sessionSelectors.getUserCountryIsoCode);
  const formattedAddress = yield* select(userAddressSelectors.getFormattedAddress);
  const countryCode = (address === null || address === void 0 ? void 0 : address.countryIsoCode) || userCountryCode;
  let latitude;
  let longitude;
  let source;
  const {
    coordinates,
    dropOffPointSource
  } = payload;

  if (coordinates) {
    latitude = coordinates.latitude;
    longitude = coordinates.longitude;
  } else if (formattedAddress) {
    const geocodedAddress = yield* call(geocodeAddress, formattedAddress);
    latitude = geocodedAddress === null || geocodedAddress === void 0 ? void 0 : geocodedAddress.geometry.location.lat();
    longitude = geocodedAddress === null || geocodedAddress === void 0 ? void 0 : geocodedAddress.geometry.location.lng();
    source = DropOffPointSource.UserAddress;
  }

  yield put(statelessActions.fetchNearbyDropOffOptionsRequest({
    countryCode,
    longitude,
    latitude,
    dropOffPointSource: source || dropOffPointSource
  }));
}
export function* fetchNearbyDropOffOptions(_ref2) {
  var _response$nearby_drop, _response$nearby_drop2;

  let {
    payload
  } = _ref2;
  const shipmentId = yield* select(conversationSelectors.getShipmentId);
  const labelTypeId = yield* select(conversationSelectors.getDigitalLabelTypeId);
  if (!shipmentId) return;
  const response = yield* call(api.getNearbyDropOffPoints, _objectSpread({
    shipmentId,
    labelTypeId
  }, payload));

  if ('errors' in response || !((_response$nearby_drop = response.nearby_drop_off_points) !== null && _response$nearby_drop !== void 0 && _response$nearby_drop.drop_off_points.length) || !((_response$nearby_drop2 = response.nearby_drop_off_points) !== null && _response$nearby_drop2 !== void 0 && _response$nearby_drop2.suggested_drop_off_point_code)) {
    yield put(actions.fetchNearbyDropOffPointFailure());
    return;
  }

  const dropOffPointResponse = transformNearbyDropOffPointDto(response.nearby_drop_off_points);
  const {
    dropOffPoints,
    suggestedDropOffPointCode,
    carrier
  } = dropOffPointResponse;
  const selectedPoint = dropOffPoints.find(point => point.code === suggestedDropOffPointCode);
  const {
    dropOffPointSource
  } = payload;
  yield put(actions.setSelectedDropOffPoint({
    selectedDropOffPoint: selectedPoint
  }));
  yield put(actions.fetchNearbyDropOffPointSuccess({
    suggestedDropOffPointCode,
    dropOffPoints,
    dropOffPointCarrier: carrier,
    dropOffPointSource
  }));
}
export default function* saga() {
  yield takeEvery(statelessActions.fetchCountryBoundsRequest, fetchCountryBounds);
  yield takeEvery(statelessActions.fetchNearbyDropOffOptionsRequest, fetchNearbyDropOffOptions);
  yield takeEvery(actions.fetchNearbyDropOffPointsRequest, fetchNearbyDropOffPoints);
}